import { useMutation, useQueryClient } from "@tanstack/react-query";
import { USERS_LIST_QUERY_KEY } from "Api/Queries/User/useUsersListQuery";
import { usersNotVerifiedKeys } from "Api/Queries/User/useUsersNotVerifiedQuery";
import {
  VERIFICATIONS_QUERY_KEY,
  getVerificationsQueryKey,
} from "Api/Queries/Verifications/useVerificationsQuery";
import {
  type UserVerificationUpdateDto,
  putVerifications,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type UseUpdateVerificationsMutationProps = {
  onSuccess?: (verificationData: UserVerificationUpdateDto) => void;
  onError?: () => void;
};

export const useUpdateVerificationsMutation = ({
  onSuccess,
  onError,
}: UseUpdateVerificationsMutationProps) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (verifications: UserVerificationUpdateDto) =>
        putVerifications(verifications),
    ),
    onSuccess: (_, data: UserVerificationUpdateDto) => {
      queryClient.invalidateQueries({
        queryKey: data.requestedUserID
          ? getVerificationsQueryKey(data.requestedUserID)
          : [VERIFICATIONS_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [USERS_LIST_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: usersNotVerifiedKeys.all,
      });
      onSuccess?.(data);
    },
    onError,
  });
};
